import React from 'react';

const Imagen = props => {
    const {large, portrait } = props.imagen.src;
    return(
        <div >
            <a href={large} target="_blank"><img className="imagen" src={portrait} /></a>
        </div>
    )
}

export default Imagen;